import React from 'react';
import {Images,TextArea,Page} from '../index';
import {Btn} from '../../Common/index';
import styled from 'styled-components';
import comic1 from '../../../asset/img/comic/otomo/comic8_1.png';
import comic2 from '../../../asset/img/comic/otomo/comic8_2.png';

const H2 = styled.h2`
 font-size: 2em;
 `

const Story6 = () => {
    return(
        <div className="common__item">
        <div className="common__center">
  <H2>立花アキトシの悩み</H2>
  <Images 
  image_1= {comic1}
  image_2= {comic2}
  style3= "display-none"
   alt_1= "立花アキトシの悩み"
   alt_2= "立花アキトシの悩み"
  />
  <TextArea 
   text1="「高橋」と「立花」と言えば「紹運」と「道雪」ですが、この源となるこっちの「立花さん」"
   text2="彼は「大友家」の謀反を二度働きます。"
   text3="一度めの謀反は敗北後にお目付役として「奴留湯さん」が置かれるのでした。"
   data="2018/07-03"
  />
  <Btn
   text="一覧に戻る"
   link="/comic"
  />
 </div>
 </div>
    )
}
export default Story6;